var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M3 193l4 0 0 -61 40 0 0 61 11 0 0 -92 40 0 0 92 10 0 0 -119 41 0 0 119 10 0 0 -146 41 0 0 146c2,0 3,1 3,3 0,2 -1,4 -3,4l-41 0 -10 0 -41 0 -10 0 -40 0 -11 0 -40 0 -4 0c-1,0 -3,-2 -3,-4 0,-2 2,-3 3,-3zm190 0l0 -139 -27 0 0 139 27 0zm-51 0l0 -112 -27 0 0 112 27 0zm-51 0l0 -85 -27 0 0 85 27 0zm-50 0l0 -55 -27 0 0 55 27 0zm-13 -110l123 -71 -19 -2c-2,0 -3,-1 -3,-3 0,-2 2,-3 4,-3 0,0 0,0 0,0l29 2c0,0 0,1 0,1 0,0 1,0 1,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 1,0 1,0 1,1 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 1,0 0,0 0,0 0,0 0,1 0,1 0,1 0,0 0,0 0,0 0,0 0,1 0,1 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,1 0,1 0,1 0,0 0,0 0,0l-12 27c-1,1 -3,2 -5,1 -2,0 -2,-2 -2,-4l8 -17 -123 71c-1,1 -3,0 -4,-1 -1,-2 -1,-4 1,-5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.61a9409e353160d88cb62525a1863569.svg";
export { ForwardRef as ReactComponent };